import { useContext } from 'react'
import { LocaleContext } from './LocaleContext'

export const useLocale = (): String => {
  const { state } = useContext(LocaleContext)

  return state?.locale ?? 'en'
}
